import superMeta from '../_CAT_ROOT_MODULE/metaCatRootModuleNode.mjs'

export default {
    ...superMeta,
    moduleIdProp: 'umId',
    moduleType: 'UM',
    name: '系统入口',
    type: 'CAT_ROOT_UM',
}
